import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { store, persistor } from "store/index";
import { Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import PhoneInputField from "components/Inputs/PhoneInputField";

const Footer = memo(({ history }) => {
  // State declarations
  const [indexModal, setIndexModal] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [center, setCenter] = useState("");
  const [process, setProcess] = useState(false);
  const [taskModal, setTaskModal] = useState(false);
  const [taskSuccessBag, setTaskSuccessBag] = useState("");
  const [taskErrorBag, setTaskErrorBag] = useState("");
  const [taskName, setTaskName] = useState("");
  const [taskPhone, setTaskPhone] = useState("");
  const [taskEmail, setTaskEmail] = useState("");
  const [taskInstitute, setTaskInstitute] = useState("");
  const [branches, setBranches] = useState([]);
  const [error, setError] = useState(null);
  const [errorBag, setErrorBag] = useState("");
  const [forceUpdateKey, setForceUpdateKey] = useState(0);

  // Validator reference
  const validator = useRef(new SimpleReactValidator());

  // Force re-render for validator messages
  const forceUpdate = useCallback(() => {
    setForceUpdateKey((prev) => prev + 1);
  }, []);

  // Lifecycle: componentDidMount
  useEffect(() => {
    if (!store.getState().token) {
      const timer = setTimeout(() => {
        setIndexModal(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Event handlers
  const closeIndexModal = useCallback((event) => {
    event.preventDefault();
    setIndexModal(false);
  }, []);

  const changeInput = useCallback((e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "center":
        setCenter(value);
        break;
      default:
        break;
    }
  }, []);

  const handlePhoneChange = useCallback((event) => {
    setPhone(event);
  }, []);

  const postSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!validator.current.allValid()) {
        validator.current.showMessages();
        forceUpdate();
        return false;
      }

      setProcess(true);
      const bodyFormData = new FormData();
      bodyFormData.append("phone", phone);
      bodyFormData.append("name", name);
      bodyFormData.append("email", email);
      bodyFormData.append("center", center);

      let res = null;
      // try {
      //   res = await API({
      //     method: "POST",
      //     url: "/submit-query",
      //     data: bodyFormData,
      //   });
      // } catch (error) {
      //   setProcess(false);
      //   return;
      // }

      if (res?.status === 200) {
        history.push({
          pathname: "/trial-class-thankyou",
          state: { flag: true },
        });
        setIndexModal(false);
      } else if (res?.response?.status === 422) {
        setError(res.response);
        setProcess(false);
        let str = "";
        Object.values(res.response.data.errors).forEach((val) => {
          str += val[0] + "\n";
        });
        setErrorBag(str);
      }
    },
    [name, phone, email, center, forceUpdate, history],
  );

  return (
    <React.Fragment>

      <footer
        id="pte-footer"
        className="pt-5 pb-3 new-design mt-5"
        style={{
          color: "white",
          backgroundColor: "#0D1830",
          backgroundImage:
            "radial-gradient(circle at bottom right,#7F56D9 0%,rgba(127, 86, 217, 0.4) 8%,rgba(127, 86, 217, 0.2) 15%,transparent 25%)",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="custom-container" style={{ color: "#C7C7C7" }}>
          {/* TOP SECTION */}
          <div className="row gy-4">
            {/* LEFT LOGO + TEXT */}
            <div className="col-lg-2">
              <div className="footer-logo mb-3">
                <a href="https://www.languageacademy.com.au/">

                {/* <Link to="/"> */}
                  <img
                    src="/images/web-new-images/new-footer-icon.png"
                    alt="LA"
                    />
                {/* </Link> */}
                    </a>
              </div>
              <p className="mb-0 plus-sans FS16FW500" style={{ color: "#C7C7C7" }}>
                At Language Academy, you can be assured that you will be
                learning from the best in the industry.
              </p>
            </div>

            {/* Middle Line Column */}
            <div className="col-auto d-flex align-items-center">
              <div className="divider-line"></div>
            </div>

            {store.getState().is_main && (
              <div className="col-lg-9 plus-sans">
                <div className="row">
                  {/* PTE */}
                  <div className="col-6 col-md-3">
                    <h6 className="mb-3 FS20FW500 fw-600 text-white">PTE</h6>
                    <ul className="list-unstyled">
                      <li>
                        {/* <Link to="/pte-coaching-classes-parramatta">
                          About PTE
                        </Link> */}
                        <a href="https://www.languageacademy.com.au/pte-coaching-classes-parramatta">About PTE</a>
                      </li>
                      <li>
                        {/* <Link to="/pte-core">About PTE Core</Link> */}
                        <a href="https://www.languageacademy.com.au/pte-core">About PTE Core</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/pte-online-coaching">Online Classes</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/pte-study-material">Study Material</a>
                      </li>
                    </ul>
                  </div>

                  {/* NAATI */}
                  <div className="col-6 col-md-3">
                    <h6 className="FS20FW500 fw-600 mb-3 text-white">NAATI</h6>
                    <ul className="list-unstyled">
                      <li>
                        <a href="https://www.languageacademy.com.au/naati-coaching-classes-parramatta">NAATI Nepali Coaching</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/naati-coaching-classes-parramatta">NAATI Punjabi Coaching</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/naati-coaching-classes-parramatta">NAATI Urdu Coaching</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/naati-coaching-classes-parramatta">NAATI Hindi Coaching</a>
                      </li>
                    </ul>
                  </div>

                  {/* ABOUT */}
                  <div className="col-6 col-md-3">
                    <h6 className="FS20FW500 fw-600 mb-3 text-white" style={{ textTransform: "unset" }}>About Us</h6>
                    <ul className="list-unstyled">
                      <li>
                        <a href="https://www.languageacademy.com.au/about">Our Story</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/sitemap">Sitemap</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/join-us">Career</a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/franchise">Franchise</a>
                      </li>
                    </ul>
                  </div>

                  {/* PRACTICE */}
                  <div className="col-6 col-md-3">
                    <h6 className="FS20FW500 fw-600 mb-3 text-white" style={{ textTransform: "unset" }}>Practice Material</h6>
                    <ul className="list-unstyled">
                      <li>
                        <a href="https://www.languageacademy.com.au/pte-reading-test-practice-material">
                          Reading
                        </a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/pte-writing-test-practice-material">
                          Writing
                        </a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/pte-listening-test-practice-material">
                          Listening
                        </a>
                      </li>
                      <li>
                        <a href="https://www.languageacademy.com.au/pte-speaking-test-practice-material">
                          Speaking
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-12 footer-bottom-contact mt-5">
                  {/* CONTACT ROW */}
                  <div className="row align-items-center gy-3">
                    {/* CALL */}
                    <div className="col-md-3">
                      <p className="fw-semibold" style={{ marginBottom: "18px" }}>Call Us</p>
                      <a href="tel:61426230061">+61 426230061</a>
                    </div>

                    {/* INQUIRY */}
                    <div className="col-md-3" style={{ wordWrap: "break-word" }}>
                      <p className="fw-semibold" style={{ marginBottom: "18px" }}>Inquiry</p>
                      <a href="mailto:info@languageacademy.com.au">
                        info@languageacademy.com.au
                      </a>
                    </div>

                    {/* ADDRESS */}
                    <div className="col-md-3">
                      <p className="fw-semibold" style={{ marginBottom: "18px" }}>Visit Us</p>
                      <span style={{ color: "#FFFFFF" }}>46 George Street, Parramatta</span>
                    </div>

                    {/* SOCIAL */}
                    {store.getState().is_main && (
                      <div className="col-md-3">
                        <p className="mb-2 fw-semibold">Follow Us On</p>
                        <div className="d-flex gap-3">
                          <a
                            href="https://www.facebook.com/languageacademyaustralia/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                          >
                            <img
                              src="/images/web-new-images/icons/fb-white.svg"
                              alt="Facebook Icon"
                            />
                          </a>
                          <a
                            href="https://www.linkedin.com/authwall?trk=gf&trkInfo=AQGxYvTu-VIE8gAAAXQBcysYhyoeMLsNbqRf-PuswFI8RzAL5y60LYHKbYMYZBVifPWMn7AFIF4-pI_yN6twk7IVrKwK8kV3mABFKcSSuEZ6xhISNB9XifF45GiA8j3LNNc6bZo=&originalReferer=https://www.languageacademy.com.au/sitemap.html&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Flanguage-academy-australia"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                          >
                            <img
                              src="/images/web-new-images/icons/linkedin-white.svg"
                              alt="LinkedIn"
                            />
                          </a>
                          <a
                            href="https://www.instagram.com/languageacademyau/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                          >
                            <img
                              src="/images/web-new-images/icons/insta-white.svg"
                              alt="Instagram"
                            />
                          </a>
                          <a
                            href="https://twitter.com/lang_acad_au"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="X"
                          >
                            <img
                              src="/images/web-new-images/icons/x-white.svg"
                              alt="X"
                            />
                          </a>
                          <a
                            href="https://www.youtube.com/channel/UC-yXI8Y7cry-D5uuNGbYbsw"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="YouTube"
                          >
                            <img
                              src="/images/web-new-images/icons/yt-white.svg"
                              alt="YouTube"
                            />
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* BOTTOM BAR */}
          <hr className="my-4" />

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
            <p className="mb-0">
              Copyright © {new Date().getFullYear()} LanguageAcademy. All rights
              reserved
            </p>

            <div className="d-flex gap-3 policies">
              {/* <Link to="/term">Terms of Use</Link> */}
              <a href="https://www.languageacademy.com.au/terms-of-use">Terms of Use</a>
              <span>•</span>
              <a href="https://www.languageacademy.com.au/privacy-policy">Privacy Policy</a>
              <span>•</span>
              <a href="https://www.languageacademy.com.au/refund-policies">Refund Policies</a>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog main-popup">
          <div className="modal-content">
            <div className="modal-header">
              {/* <button onClick={closeIndexModal} style={{ color: "#93c13e", opacity: "unset" }} href="#" className="close">
                <span aria-hidden="true">
                  <img className="img-fluid" src="/images/web-new-images/icons/close-icon2.svg" alt="LA" />
                </span>
              </button> */}
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  const modalEl = document.getElementById("staticBackdrop");
                  modalEl.classList.remove("show");
                  modalEl.style.display = "none";
                  document.body.classList.remove("modal-open");
                  document.body.style.removeProperty("overflow");
                  document.body.style.removeProperty("padding-right");
                  const backdrop = document.querySelector(".modal-backdrop");
                  if (backdrop) backdrop.remove();
                }}
              >
                <span aria-hidden="true">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/icons/close-icon2.svg"
                    alt="LA"
                  />
                </span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="form-content-outer m-0">
                <div className="form-content">
                  <div className="main-popup-img form-img">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/hero_img-02.png"
                      alt="LA"
                    />
                  </div>
                  <div className="main-popup-content form-content-right">
                    <h4 className="popup-title">
                      Attend a FREE TRIAL CLASS for PTE, NAATI CCL or IELTS with
                      us.
                    </h4>
                    <p className="popup-sub-title">Submit Your Details Below</p>
                    <div className="pte-popup-form-start">
                      <form onSubmit={postSubmit}>
                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="Name">Name*</label>
                            <div className="form-input-outer">
                              <input
                                id="Name"
                                className="form-input"
                                name="name"
                                placeholder="Enter Name"
                                type="text"
                                value={name}
                                onChange={changeInput}
                              />
                            </div>
                            {validator.current.message("name", name, "required")}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <PhoneInputField
                              value={phone}
                              changeEvent={handlePhoneChange}
                              addClass="popup-class"
                            />
                            {validator.current.message("phone", phone, "required|phone")}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="email">Email*</label>
                            <div className="form-input-outer">
                              <input
                                id="email"
                                className="form-input"
                                name="email"
                                placeholder="Enter Email"
                                type="email"
                                value={email}
                                onChange={changeInput}
                              />
                            </div>
                            {validator.current.message("email", email, "required|email")}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="fieldOuter">
                            <label htmlFor="Center">Center</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                id="Center"
                                className="form-input"
                                name="center"
                                value={center}
                                onChange={changeInput}
                              >
                                <option value="">Select center</option>
                                <option>Parramatta</option>
                                <option>Sydney CBD</option>
                                <option>Jalandhar</option>
                                <option>Gurdaspur</option>
                                <option>Amristar</option>
                                <option>Sirsa</option>
                                <option>Sri Ganganagar</option>
                                <option>Kurukshetra</option>
                                <option>Online</option>
                              </select>
                            </div>
                            {validator.current.message("center", center, "required")}
                          </div>
                        </div>

                        <div className="col-md-12 row_before_pte_submit">
                          {!process ? (
                            <button type="submit" className="primary-btn">
                              SUBMIT{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="LA"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary pte_popup_modal_submit"
                              disabled
                            >
                              Wait...
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});

export default Footer;
